export const translations = {
  pl: {
    header: {
      about: "Dlaczego Vortex",
      solutions: "Produkt",
      method: "Jak działa aplikacja",
      universities: "Dla uczelni",
      standards: "Zasady",
      recognition: "Osiągnięcia",
      contact: "Kontakt",
      cta: "Rozpocznij"
    },
    hero: {
      eyebrow: "VORTEX ORGANIZATION INTELLIGENCE",
      title_line1: "Jasność",
      title_line2: "w",
      title_line3: "Chaosie.",
      description: "Konfigurowalna warstwa intelligence dla zespołów, które nie mogą sobie pozwolić na opóźnienia. Łączymy dane rynkowe, satelitarne, sentyment i logistykę z Twoimi systemami wewnętrznymi. Ty decydujesz, co badamy i jak oceniamy sygnały.",
      cta_primary: "Poproś o dostęp",
      cta_secondary: "Zobacz film",
      cta_secondary_contact: "Skontaktuj się"
    },
    ticker: {
      partner: "Programy i wyróżnienia"
    },
    features: {
      section_subtitle: "DWIE LINIE PRODUKTU",
      section_title: "Aplikacja dla organizacji. Scenariusze do ćwiczenia decyzji.",
      section_desc: "Aplikacja dobiera dane i monitoruje uzgodnione warunki. Scenarios / University Lab wykorzystuje ten sam fundament do ćwiczeń decyzyjnych dla zespołów i uczelni.",
      platform: {
        number: "01",
        title: "Aplikacja Vortex",
        subtitle: "Intelligence dopasowane do twojej organizacji",
        desc: "W aplikacji opisujesz działalność, potrzeby i ryzyka. Vortex dobiera źródła, łączy je z danymi własnymi i pozwala ustawić warunki, przy których zespół ma dostać sygnał.",
        status: "Działająca aplikacja"
      },
      scenarios: {
        number: "02",
        title: "Scenarios / University Lab",
        subtitle: "Ćwiczenia decyzyjne dla zespołów i uczelni",
        desc: "Kontrolowane scenariusze, w których uczestnicy pracują na zmieniających się informacjach, podejmują decyzje i zachowują materiał do późniejszego omówienia.",
        status: "Demo + pilot akademicki"
      },
      platform_cta: "Ustal zakres i wycenę aplikacji",
      scenarios_cta: "Ustal zakres i wycenę scenariuszy",
      scenarios_details: "Zobacz pełny scenariusz: Wielka Woda 48H",
      foundation_label: "WSPÓLNY RDZEŃ",
      foundation: "Obie linie korzystają ze wspólnej warstwy map, danych operacyjnych, źródeł i historii zmian. Zakres, integracje i cena są ustalane indywidualnie."
    },
    about: {
      subtitle: "APLIKACJA DLA ORGANIZACJI",
      title: "Najpierw potrzeba. Potem sygnał.",
      body_p1: "W aplikacji opisujesz, czym zajmuje się organizacja, co może zakłócić jej działanie i o jakich zmianach chcesz wiedzieć wcześniej.",
      body_p2: "Aplikacja przekłada ten opis na dopasowany zestaw źródeł i wskazuje informacje potrzebne do monitorowania wybranych warunków.",
      body_p3: "Możesz połączyć własne dokumenty, bazy lub API. Zasady dostępu, jakości i bezpieczeństwa ustalamy przed uruchomieniem.",
      body_p4: "Zakres źródeł, integracji, monitoringu i dostępu dopasowujemy do potrzeb oraz sposobu pracy organizacji.",
      steps: ["Potrzeba", "Źródła", "Monitoring"],
      invite: "Poznaj produkty"
    },
    data_sources: {
      subtitle: "JAK DZIAŁA APLIKACJA",
      title: "W aplikacji opisujesz potrzebę. Vortex ustawia monitoring.",
      desc: "Konfiguracja odbywa się w aplikacji Vortex. Podajesz kontekst organizacji, wskazujesz to, czego nie chcesz przegapić, i określasz moment, w którym potrzebna jest informacja.",
      items: {
        connect: { title: "Opisz organizację w aplikacji", desc: "Wskaż działalność, potrzeby, ryzyka i zakłócenia, o których zespół powinien wiedzieć wcześniej." },
        research: { title: "Vortex dobiera źródła", desc: "Aplikacja proponuje dane publiczne, licencjonowane, branżowe lub geoprzestrzenne dopasowane do twojej potrzeby." },
        byo_data: { title: "Dodaj własne dane", desc: "W aplikacji możesz połączyć dokumenty, bazy lub API zgodnie z uzgodnionymi zasadami dostępu i bezpieczeństwa." },
        alerts: { title: "Ustal warunki powiadomień", desc: "Określasz warunki, progi i odbiorców. Aplikacja monitoruje uzgodnione sygnały i pokazuje alert wraz z kontekstem oraz źródłem." }
      }
    },
    engineering: {
      subtitle: "VORTEX DNA",
      title: "Zasady projektowe",
      desc: "Każde wdrożenie zaczyna się od jawnego pytania, granic danych i kryteriów odbioru. Technologia ma wspierać decyzję, nie ukrywać założeń.",
      data_sovereignty: {
        title: "Granice danych",
        desc: "Ustalamy, co może wejść do rozwiązania, gdzie może być przetwarzane i czego nie wolno wysyłać przez formularz."
      },
      precision_eng: {
        title: "Pytanie decyzyjne",
        desc: "Każdy scenariusz i każda warstwa danych odpowiada na konkretne pytanie, rolę oraz horyzont czasu."
      },
      transparent_ai: {
        title: "Pochodzenie informacji",
        desc: "Źródło, rola materiału i kluczowe założenia mają być widoczne w przeglądzie pracy zespołu."
      },
      api_independence: {
        title: "Zakres bez blokady",
        desc: "Zakres ma określone wejścia, wyjścia i kryteria odbioru. Dalsze integracje są osobną, świadomą decyzją."
      }
    },
    recognition: {
      award_badge: "Diamond Shields Award 2025",
      title_line1: "Osiągnięcia",
      title_line2: "z kontekstem",
      description: "Wyróżnienia Vortex i dorobek zespołu pokazują zdolność łączenia technologii, analizy oraz decyzji pod presją.",
      read_article: "Czytaj artykuł",
      award_card: {
        winner: "Winner",
        title: "Nagroda Diamentowe Tarcze",
        event: "Kongres Bezpieczeństwa Polskiego",
        role: "Security Innovator of the Year"
      },
      show_articles: "Pokaż artykuły",
      hide_articles: "Ukryj artykuły",
      articles: {
        radio: {
          title: "Laureaci Diamentowych Tarcz",
          desc: "Relacja z wydarzenia i lista laureatów konkursu Diamentowe Tarcze 2025."
        },
        nowiny: {
          title: "Kongres Bezpieczeństwa Polskiego",
          desc: "Materiał o gali Kongresu Bezpieczeństwa Polski i przyznanych wyróżnieniach."
        },
        czytaj: {
          title: "Liderzy Innowacji",
          desc: "Relacja medialna z konkursu oraz prezentacji nagrodzonych projektów."
        },
        samorzad: {
          title: "Gala Kongresu",
          desc: "Prestiżowa nagroda Diamentowe Tarcze za doskonałość w innowacjach bezpieczeństwa."
        }
      },
      mazovian: {
        place: "Miejsce",
        title: "Mazovian Startup",
        organizer: "Urząd Marszałkowski Województwa Mazowieckiego",
        partner_award: "Nagroda partnera: OVH Cloud",
        article_title: "Nagrodzeni w 5. edycji Mazovian Startup",
        article_source: "Biuro Prasowe Urzędu Marszałkowskiego"
      }
    },
    contact: {
      title_line1: "Ustalmy",
      title_line2: "zakres i wycenę",
      description: "Skontaktuj się, aby ustalić zakres aplikacji, integracje, dostęp, scenariusze oraz indywidualną wycenę.",
      email_label: "Email",
      location_label: "Siedziba",
      location_value: "Radom, Polska",
      form: {
        first_name: "Imię",
        last_name: "Nazwisko",
        company: "Organizacja",
        work_email: "E-mail służbowy",
        interest_label: "Interesuje mnie",
        interest_options: {
          data_configuration: "Aplikacja Vortex dla organizacji",
          scenario_products: "Scenarios / University Lab",
          other: "Inne / Konsultacja"
        },
        interest_error: "Wybierz co najmniej jeden obszar.",
        message: "Wiadomość",
        message_placeholder: "Napisz krótko, czym zajmuje się organizacja, czego potrzebuje i jaki zakres chcesz wycenić.",
        submit: "Zapytaj o zakres i wycenę",
        sending: "Wysyłanie...",
        validation_error: "Uzupełnij wymagane pola.",
        success: "Dziękujemy. Wrócimy z pytaniami potrzebnymi do ustalenia zakresu i wyceny.",
        send_error: "Nie udało się wysłać formularza. Spróbuj ponownie.",
        privacy: "Twoje dane są przetwarzane zgodnie z naszą",
        privacy_link: "Polityką Prywatności"
      }
    },
    footer: {
      mission: "Aplikacja dopasowująca źródła i monitoring do potrzeb organizacji oraz scenariusze do ćwiczenia decyzji.",
      col_solutions: "Oferta",
      col_company: "Firma",
      col_socials: "Obserwuj nas",
      links: {
        simulators: "Scenarios / University Lab",
        university: "Dla uczelni",
        configuration: "Aplikacja Vortex",
        about: "Dlaczego Vortex",
        media: "Osiągnięcia",
        contact: "Kontakt"
      },
      rights: "Wszelkie prawa zastrzeżone.",
      back_to_top: "Wróć na górę",
      privacy: "Polityka Prywatności",
      terms: "Regulamin",
      legal: {
        company_name: "VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością",
        registered_office: "Siedziba: Radom · Adres: ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, Polska",
        registry: "KRS 0001242033 · NIP 7963047559 · Kapitał zakładowy: 5 000 zł",
        court: "Sąd Rejonowy Lublin-Wschód w Lublinie z siedzibą w Świdniku, VI Wydział Gospodarczy Krajowego Rejestru Sądowego"
      },
      funding: {
        eu_logo_alt: "Fundusze Europejskie dla Polski Wschodniej, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską, PARP",
        notice: "Projekt finansowany w ramach Platformy Startowej Centralny Akcelerator Innowacji „Mazovian StartUPolis”, współfinansowanej ze środków Unii Europejskiej w ramach programu Fundusze Europejskie dla Polski Wschodniej 2021-2027. Priorytet FEPW.01 Przedsiębiorczość i Innowacje. Działanie FEPW.01.01 Platformy startowe dla nowych pomysłów. Komponent I Inkubacja - rozwój nowego pomysłu biznesowego."
      }
    },
    privacy_policy: {
      metadata: {
        status: "STATUS: AKTYWNY",
        version: "WERSJA: 2.2.0",
        date: "DATA: 2026-08-17",
        hash: "REF: 0x7F3A...9C"
      },
      title: "Protokół Ochrony Danych",
      collection_title: "1. Suwerenność i Minimalizacja Danych",
      collection_text: "Przez stronę przetwarzamy dane podane w formularzach oraz dane techniczne potrzebne do działania i ochrony serwisu. Analityka uruchamia się dopiero po uzyskaniu zgody.",
      purpose_title: "2. Cel i Mandat Operacyjny",
      purpose_text: "Dane służą do odpowiedzi na zapytania, obsługi wniosków dotyczących praw, działania i ochrony serwisu oraz, po uzyskaniu zgody, analizy sposobu korzystania ze strony. Nie sprzedajemy danych użytkowników.",
      security_title: "3. Postawa Bezpieczeństwa (Security Posture)",
      security_text: "Stosujemy środki techniczne i organizacyjne odpowiednie do charakteru serwisu. Nie przesyłaj przez formularze informacji niejawnych, danych studentów ani poufnych materiałów organizacji.",
      rights_title: "4. Autonomia Podmiotu i Opt-out",
      rights_text: "Możesz skorzystać z praw dostępu, sprostowania, usunięcia, ograniczenia i sprzeciwu, jeśli mają zastosowanie. Poniżej możesz także zablokować skrypty analityczne.",
      opt_out: {
        google: "Blokuj Google Analytics",
        clarity: "Blokuj MS Clarity"
      },
      dsar: {
        label: "Generuj Wniosek RODO (Art. 17)",
        subject: "WNIOSEK RODO: Usunięcie danych (Art. 17)",
        body: "Dzień dobry,%0D%0A%0D%0ANa podstawie Art. 17 RODO wnoszę o niezwłoczne usunięcie moich danych osobowych z Państwa rejestrów.%0D%0A%0D%0AIdentyfikator/Email: [Wpisz email]%0D%0A%0D%0AZ poważaniem,"
      },
      contact_title: "5. Nadzór i Kontakt",
      contact_text: "Administratorem danych jest VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością z siedzibą w Radomiu, ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, KRS 0001242033, NIP 7963047559. Kontakt w sprawach prywatności: contact@vortexanalytica.com.",
      close: "Zamknij"
    },
    cookies: {
      text: "Za Twoją zgodą używamy GA4 i Clarity, aby zrozumieć korzystanie ze strony i ją ulepszać. Czy chcesz włączyć analitykę?",
      accept: "Akceptuj Analitykę",
      decline: "Odrzuć"
    },
    terms: {
      metadata: {
        status: "STATUS: ENFORCED",
        version: "WERSJA: 1.5.0",
        date: "DATA: 2026-08-17",
        hash: "REF: 0xB29...1A"
      },
      title: "Warunki Użytkowania Serwisu",
      sec1_title: "1. Postanowienia Ogólne i Definicje",
      sec1_text: "Operatorem serwisu jest VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością z siedzibą w Radomiu, ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, KRS 0001242033, NIP 7963047559. Serwis ma charakter informacyjny i przedstawia aplikację Vortex oraz produkty Scenarios / University Lab. Zawartość nie stanowi oferty w rozumieniu art. 66 Kodeksu cywilnego.",
      sec2_title: "2. Własność Intelektualna (IP)",
      sec2_text: "Aktywa cyfrowe, kod źródłowy, materiały scenariuszowe, nazwy handlowe i identyfikacja wizualna podlegają ochronie zgodnie z obowiązującym prawem oraz prawami odpowiednich podmiotów. Kopiowanie lub wykorzystywanie bez właściwej podstawy jest zabronione.",
      sec3_title: "3. Dostęp do Wczesnych Wersji (Early Access)",
      sec3_text: "Demonstratory, pilotaże i dedykowane Scenario Packi mają odrębnie uzgadniany zakres. Dostęp, zasady użycia, dane, wsparcie oraz kryteria odbioru mogą wymagać osobnego porozumienia.",
      sec4_title: "4. Wyłączenie Odpowiedzialności",
      sec4_text: "Publiczna strona ma charakter informacyjny. Nie stanowi rekomendacji operacyjnej, inwestycyjnej, prawnej ani strategicznej. Warunki konkretnego pilotażu lub wdrożenia określa osobna umowa.",
      sec5_title: "5. Jurysdykcja",
      sec5_text: "Wszelkie spory podlegają prawu polskiemu. Właściwość sądu ustala się zgodnie z bezwzględnie obowiązującymi przepisami prawa; siedzibą VORTEX ANALYTICA sp. z o.o. jest Radom.",
      close: "Zamknij"
    },
    dsar_modal: {
      title: "Wniosek o Realizację Praw (RODO)",
      desc: "Skorzystaj z tego bezpiecznego kanału, aby zarządzać swoimi danymi osobowymi. Odpowiedź otrzymasz w ciągu 30 dni.",
      request_type: "Typ Wniosku",
      types: {
        deletion: "Art. 17 - Prawo do bycia zapomnianym (Usunięcie)",
        access: "Art. 15 - Prawo dostępu do danych (Kopia)",
        rectification: "Art. 16 - Prawo do sprostowania danych"
      },
      email_label: "Adres Email Wnioskodawcy",
      email_placeholder: "Podaj email użyty w systemie...",
      id_label: "Dodatkowy Identyfikator (Opcjonalnie)",
      details_label: "Szczegóły Żądania",
      submit: "Wyślij Wniosek Oficjalny",
      success: "Wniosek został wysłany. Odpowiemy na podany adres e-mail.",
      error: "Błąd wysyłania. Spróbuj ponownie.",
      cancel: "Anuluj"
    }
  },
  en: {
    header: {
      about: "Why Vortex",
      solutions: "Product",
      method: "How the application works",
      universities: "For universities",
      standards: "Principles",
      recognition: "Recognition",
      contact: "Contact",
      cta: "Get Started"
    }, hero: {
      eyebrow: "VORTEX ORGANIZATION INTELLIGENCE",
      title_line1: "Clarity",
      title_line2: "in",
      title_line3: "Chaos.",
      description: "Configurable intelligence layer for teams that can't afford delays. We connect market, satellite, sentiment, and logistics data with your internal systems. You decide what we research and how we score signals.",
      cta_primary: "Request Access",
      cta_secondary: "Watch Film",
      cta_secondary_contact: "Contact Us"
    },
    ticker: {
      partner: "Programs and recognition"
    },
    features: {
      section_subtitle: "TWO PRODUCT LINES",
      section_title: "An application for organizations. Scenarios for decision practice.",
      section_desc: "The application selects data and monitors agreed conditions. Scenarios / University Lab uses the same foundation for decision exercises with teams and universities.",
      platform: {
        number: "01",
        title: "Vortex Application",
        subtitle: "Intelligence configured around your organization",
        desc: "In the application, you describe the operation, needs, and risks. Vortex recommends sources, combines them with your own data, and lets you define the conditions that should trigger a signal for the team.",
        status: "Working application"
      },
      scenarios: {
        number: "02",
        title: "Scenarios / University Lab",
        subtitle: "Decision exercises for teams and universities",
        desc: "Controlled scenarios in which participants work with evolving information, make decisions, and retain the material required for structured review.",
        status: "Demo + academic pilot"
      },
      platform_cta: "Discuss application scope and pricing",
      scenarios_cta: "Discuss scenario scope and pricing",
      scenarios_details: "View the full scenario: High Water 48H",
      foundation_label: "SHARED CORE",
      foundation: "Both lines use a shared layer of maps, operational data, sources, and change history. Scope, integrations, and pricing are agreed individually."
    },
    about: {
      subtitle: "APPLICATION FOR ORGANIZATIONS",
      title: "Start with the need. Then find the signal.",
      body_p1: "In the application, you describe what the organization does, what could disrupt its operations, and which changes the team wants to know about earlier.",
      body_p2: "The application turns that description into a tailored source set and identifies the information required to monitor the selected conditions.",
      body_p3: "You can connect your own documents, databases, or APIs. Access, quality, and security rules are agreed before launch.",
      body_p4: "The source, integration, monitoring, and access scope is tailored to the organization's needs and way of working.",
      steps: ["Need", "Sources", "Monitoring"],
      invite: "Explore products"
    },
    data_sources: {
      subtitle: "HOW THE APPLICATION WORKS",
      title: "You describe the need in the application. Vortex configures the monitoring.",
      desc: "Configuration happens in the Vortex application. Add the organization context, identify what it cannot afford to miss, and define the moment when information is needed.",
      items: {
        connect: { title: "Describe the organization in the application", desc: "Identify the operation, needs, risks, and disruptions the team wants to know about earlier." },
        research: { title: "Vortex recommends the sources", desc: "The application proposes public, licensed, industry, or geospatial data matched to your need." },
        byo_data: { title: "Add your own data", desc: "In the application, you can connect documents, databases, or APIs under agreed access and security rules." },
        alerts: { title: "Define notification conditions", desc: "Set conditions, thresholds, and recipients. The application monitors the agreed signals and presents an alert with context and source provenance." }
      }
    },
    engineering: {
      subtitle: "VORTEX DNA",
      title: "Design principles",
      desc: "Every deployment starts with a visible question, data boundaries, and acceptance criteria. Technology should support the decision, not hide its assumptions.",
      data_sovereignty: {
        title: "Data boundaries",
        desc: "We agree what may enter the solution, where it may be processed, and what must never be submitted through a form."
      },
      precision_eng: {
        title: "Decision question",
        desc: "Each scenario and data layer answers a specific question for a defined role and time horizon."
      },
      transparent_ai: {
        title: "Information provenance",
        desc: "The source, role of the material, and key assumptions should remain visible during structured review."
      },
      api_independence: {
        title: "Scope without lock-in",
        desc: "The scope has explicit inputs, outputs, and acceptance criteria. Further integrations remain a separate, deliberate decision."
      }
    },
    recognition: {
      award_badge: "Diamond Shields Award 2025",
      title_line1: "Recognition",
      title_line2: "with context",
      description: "Vortex distinctions and team track record show an ability to combine technology, analysis, and decisions under pressure.",
      read_article: "Read Article",
      award_card: {
        winner: "Winner",
        title: "Diamond Shields Award",
        event: "Polish Security Congress",
        role: "Security Innovator of the Year"
      },
      show_articles: "Show Articles",
      hide_articles: "Hide Articles",
      articles: {
        radio: {
          title: "Diamond Shields Winners",
          desc: "Event coverage and the list of winners of the 2025 Diamond Shields competition."
        },
        nowiny: {
          title: "Polish Security Congress",
          desc: "Coverage of the Polish Security Congress gala and its distinctions."
        },
        czytaj: {
          title: "Innovation Leaders",
          desc: "Media coverage of the competition and presentations by awarded projects."
        },
        samorzad: {
          title: "Congress Gala",
          desc: "Prestigious Diamond Shields award for excellence in security innovation."
        }
      },
      mazovian: {
        place: "Place",
        title: "Mazovian Startup Award",
        organizer: "Marshal's Office of Mazowieckie Voivodeship",
        partner_award: "Partner Award: OVH Cloud",
        article_title: "Awarded in the 5th Mazovian Startup Edition",
        article_source: "Press Office of the Marshal's Office"
      }
    },
    contact: {
      title_line1: "Let us agree",
      title_line2: "scope and pricing",
      description: "Contact us to agree the application scope, integrations, access, scenarios, and individual pricing.",
      email_label: "Email",
      location_label: "HQ",
      location_value: "Radom, Poland",
      form: {
        first_name: "First Name",
        last_name: "Last Name",
        company: "Organization",
        work_email: "Work Email",
        interest_label: "I am interested in",
        interest_options: {
          data_configuration: "Vortex application for an organization",
          scenario_products: "Scenarios / University Lab",
          other: "Other / Consultation"
        },
        interest_error: "Select at least one area.",
        message: "Message",
        message_placeholder: "Briefly describe the organization, what it needs, and which scope you would like us to price.",
        submit: "Ask about scope and pricing",
        sending: "Sending...",
        validation_error: "Complete the required fields.",
        success: "Thank you. We will return with the questions needed to agree scope and pricing.",
        send_error: "The form could not be sent. Please try again.",
        privacy: "Your data is processed according to our",
        privacy_link: "Privacy Policy"
      }
    },
    footer: {
      mission: "An application that matches sources and monitoring to organization needs, plus scenarios for decision practice.",
      col_solutions: "Offer",
      col_company: "Company",
      col_socials: "Follow Us",
      links: {
        simulators: "Scenarios / University Lab",
        university: "For universities",
        configuration: "Vortex Application",
        about: "Why Vortex",
        media: "Recognition",
        contact: "Contact"
      },
      back_to_top: "Back to Top",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      legal: {
        company_name: "VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością",
        registered_office: "Registered office: Radom · Address: ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, Poland",
        registry: "National Court Register (KRS): 0001242033 · Tax ID (NIP): 7963047559 · Share capital: PLN 5,000.00",
        court: "Registration court: District Court Lublin-East in Lublin, with its seat in Świdnik, 6th Commercial Division of the National Court Register"
      },
      funding: {
        eu_logo_alt: "European Funds for Eastern Poland, Republic of Poland, Co-funded by the European Union, PARP",
        notice: "This project is funded under the Central Innovation Accelerator “Mazovian StartUPolis” Startup Platform and co-financed by the European Union through the European Funds for Eastern Poland 2021-2027 programme. Priority FEPW.01: Entrepreneurship and Innovation. Measure FEPW.01.01: Startup Platforms for New Ideas. Component I: Incubation - Development of a New Business Idea."
      }
    },
    privacy_policy: {
      metadata: {
        status: "STATUS: ACTIVE",
        version: "VERSION: 2.2.0",
        date: "DATE: 2026-08-17",
        hash: "REF: 0x7F3A...9C"
      },
      title: "Data Protection Protocol",
      collection_title: "1. Data Sovereignty & Minimization",
      collection_text: "Through this website we process data submitted in forms and technical data needed to operate and protect the service. Analytics is activated only after consent.",
      purpose_title: "2. Purpose & Operational Mandate",
      purpose_text: "Data is used to respond to enquiries, handle rights requests, operate and protect the website, and, after consent, understand how the site is used. We do not sell user data.",
      security_title: "3. Security Posture",
      security_text: "We apply technical and organisational measures appropriate to this website. Do not submit classified information, student data, or confidential organizational material through a form.",
      rights_title: "4. Subject Autonomy & Opt-out",
      rights_text: "You may exercise rights of access, rectification, erasure, restriction, and objection where applicable. You can also block analytics scripts below.",
      opt_out: {
        google: "Block Google Analytics",
        clarity: "Block MS Clarity"
      },
      dsar: {
        label: "Generate GDPR Request (Art. 17)",
        subject: "GDPR REQUEST: Data Erasure (Art. 17)",
        body: "To Whom It May Concern,%0D%0A%0D%0APursuant to Article 17 of the GDPR, I hereby request the immediate erasure of my personal data from your registries.%0D%0A%0D%0AIdentifier/Email: [Insert Email]%0D%0A%0D%0ASincerely,"
      },
      contact_title: "5. Governance & Contact",
      contact_text: "The Data Controller is VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością, with its registered office in Radom at ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, Poland, KRS 0001242033, NIP 7963047559. Privacy contact: contact@vortexanalytica.com.",
      close: "Close"
    },
    cookies: {
      text: "With your consent, we use GA4 and Clarity to understand website use and improve it. Would you like to enable analytics?",
      accept: "Accept Analytics",
      decline: "Decline"
    },
    terms: {
      metadata: {
        status: "STATUS: ENFORCED",
        version: "VERSION: 1.5.0",
        date: "DATE: 2026-08-17",
        hash: "REF: 0xB29...1A"
      },
      title: "Terms of Service",
      sec1_title: "1. General Provisions & Scope",
      sec1_text: "The website is operated by VORTEX ANALYTICA spółka z ograniczoną odpowiedzialnością, with its registered office in Radom at ul. Kazimierza Pułaskiego 6/10, 26-600 Radom, Poland, KRS 0001242033, NIP 7963047559. It is informational and presents the Vortex application and Scenarios / University Lab products. Its content does not constitute a binding commercial offer.",
      sec2_title: "2. Intellectual Property Rights",
      sec2_text: "Digital assets, source code, scenario materials, trade names, and visual identity are protected under applicable law and the rights of their respective owners. Copying or use without a proper legal basis is prohibited.",
      sec3_title: "3. Early Access & Restricted Systems",
      sec3_text: "Demonstrators, pilots, and dedicated Scenario Packs have a separately agreed scope. Access, permitted use, data, support, and acceptance criteria may require a separate agreement.",
      sec4_title: "4. Disclaimer of Warranties & Liability",
      sec4_text: "The public website is informational. It is not an operational, investment, legal, or strategic recommendation. The terms of a specific pilot or deployment are defined in a separate agreement.",
      sec5_title: "5. Governing Law",
      sec5_text: "Any disputes shall be governed by Polish law. The competent court shall be determined under mandatory law; the registered office of VORTEX ANALYTICA sp. z o.o. is in Radom.",
      close: "Close"
    },
    dsar_modal: {
      title: "Data Subject Access Request (GDPR)",
      desc: "Use this secure channel to exercise your data rights. We will respond within 30 days.",
      request_type: "Request Type",
      types: {
        deletion: "Art. 17 - Right to Erasure (Be Forgotten)",
        access: "Art. 15 - Right of Access (Data Copy)",
        rectification: "Art. 16 - Right to Rectification"
      },
      email_label: "Requester Email",
      email_placeholder: "Enter email used in the system...",
      id_label: "Additional ID (Optional)",
      details_label: "Request Details",
      submit: "Submit Official Request",
      success: "Your request has been sent. We will respond to the email provided.",
      error: "Submission error. Please try again.",
      cancel: "Cancel"
    }
  }
};
